import { useContext, useEffect } from 'react';
import { SubStepsContext } from '../components/SubSteps';
import { TimelineContext } from '../lib/Timeline';
const defaultOptions = {
  duration: {
    fast: 300,
    normal: 400,
    slow: 800
  }
};
export const useStep = (index, getFrames, options = {}) => {
  const timeline = useContext(TimelineContext);
  const subId = useContext(SubStepsContext);
  const _options$deps = options.deps,
        deps = _options$deps === void 0 ? [] : _options$deps;
  useEffect(() => {
    if (index === undefined || !getFrames || !deps.every(d => d)) return;
    timeline.addStep({
      id: [...subId, index],
      getStepFrames: () => getFrames(defaultOptions),
      options
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};